import getFeatureLabel from './getFeatureLabel.js';
import UserLayer from '../customer-metadata/UserLayer.js';
import FeatureReference from '../features/FeatureReference.js';
/**
 * @memberof geodata
 * @description This should probably become something other than the
 * frontend's concern eventually.
 *
 * @param {geodata.FeatureCollection} featureCollection
 * @return {Promise.<geodata.FeatureCollection>}
 */
function populateFeatureLabels(featureCollection) {
    const layers = {};
    const references = featureCollection.features.map((feature) => {
        const reference = FeatureReference.fromKey(feature.key.toString());
        if (reference.type === FeatureReference.SourceType.CUSTOMER && !layers[reference.sourceId]) {
            layers[reference.sourceId] = UserLayer.retrieve(reference.sourceId);
        }
        return reference;
    });
    return Promise.all(Object.values(layers)).then((layers) => {
        const layersById = layers.reduce((memo, layer) => {
            memo[layer.id] = layer;
            return memo;
        }, {});
        featureCollection.features.forEach((feature, i) => {
            const reference = references[i];
            const isUserFeature = reference.type === FeatureReference.SourceType.CUSTOMER;
            feature.label = isUserFeature
                ? getFeatureLabel(layersById[reference.sourceId], feature, reference.id - 1)
                : (feature.properties.label || feature.properties.label_long);
        });
        return featureCollection;
    });
}
export default populateFeatureLabels;
